import React from "react";
import Modal from '../Modal'
import LoaderButton from "../LoaderButton";
import { checkTranslation, translate } from "../../utils/useful";
import FormViewer from "../FormViewer";
import SwitchInput from "../inputs/SwitchInput";
import TopicView from "../views/messenger/sideBar/TopicView";
import StagesManager from "../StagesManager";
import TableViewer from "../TableViewer";
import FixedView from "../FixedView";


class ImportModalThird extends React.Component {
    state = {
        files: [
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
            { icon: "/assets/icons/uploadmodal/filesingle.svg", title: "Table-1 Grid-View.cvs", size: "171B" },
        ],

        // headers: [
        //     { key: 'name', type: 'TextInput', information: { label: 'NAME' } },
        //     { key: 'invoice count', type: 'TextInput', information: { label: 'INVOICE COUNT' } },
        //     { key: 'sales', type: 'TextInput', information: { label: 'SALES' } },
        //     { key: 'sales with tax', type: 'TextInput', information: { label: 'SALES WITH TAX' } },
        //     { key: 'cDate', type: 'DateInput', information: { label: 'Creation Date' } },
        //     // { key: 'restrictions', type: 'TextInput', information: { label: 'Restrictions' } },
        // ],

        setting: [
            { title: "{{lang}}Exclude first row in import" },
            { title: "{{lang}}Create missing select options" },
        ],

        // map: [
        //     { title: "Exclode first row in import" },
        //     { title: "Creat missing select options" },
        // ]

    }


    openSettingView = () => {
        this.settingView.showView()
    }

    render() {
        return (


            <div className="w-100 h-100 br-10 sc-gray2" style={{ backgroundColor: "white", overflowY: "scroll" }}>
                <div className="p-4">
                    <p className="font-size-20 weight-500" style={{ color: "#444" }}>{translate('Import Into Untitled Base — Table 1')}</p>
                    <p className="font-size-12 eight-300" style={{ color: "#666" }}>{translate("Here's the data you're importing—check to make sure it's right or let us know if something looks wrong")}.</p>
                    <div className="py-3" style={{}}>
                        {/* <TableViewer
                            // isLoading={this.state.isLoading}
                            headers={this.state.headers}
                            data={this.state.chart}
                            ref={el => this.TableViewer = el}
                        /> */}
                        <div className="h-100 br-5 py-3 flexcc flex-column " style={{ border: "1px dashed #4185FA" }}>
                            <img width={80} src="/assets/icons/uploadmodal/file.svg" />
                            <p>{translate('Select a file to upload')}</p>
                            <p className="font-size-10" style={{ color: "#777" }}>{translate('or drag and drop, copy and paste file')}.</p>
                        </div>
                    </div>
                    <div className="p-3 br-5 flexcb" style={{ backgroundColor: "#eee" }}>
                        <p>{translate('Adjust your import')}</p>
                        <div ref={el => this.settingNode = el} >
                            <button className="flexc" onClick={() => this.openSettingView()} >
                                <img width={22} src="/assets/icons/uploadmodal/gearshape.svg" />
                                <p className="mx-1" style={{ color: "#555" }}>{translate('Other Settings')}</p>
                                <img width={22} src="/assets/icons/uploadmodal/arrow-down-black.svg" />
                            </button>
                        </div>
                    </div>
                    <div className="pt-3 pb-1">
                        <p className="font-size-12 eight-300" style={{ color: "#333" }}>{translate("You're importing 4 new records from Table 1-Grid view.csv to Table 1")}</p>
                    </div>
                    <div className="d-flex mt-4" style={{ justifyContent: "flex-end" }}>
                        <button className="px-3 py-2 br-5" style={{ border: "1px solid #555" }}>
                            <p style={{ color: "#555" }}>{translate('Cancel')}</p>
                        </button>
                        <button className="blue-btn px-3 py-2 br-5 mld-4">
                            <p className="white">{translate('Import')}</p>
                        </button>
                    </div>
                </div>
                <FixedView ref={el => this.settingView = el} nodeRef={this.settingNode} showFocus={false} topOffset={5} xOffset={0} zIndex={10} >
                    <div className='shadow-2 px-3 py-1 br-10' style={{ backgroundColor: "#fff", width: "max-Content" }}>
                        {this.state.setting.map((prop, index) => {
                            return (
                                <div className="flexc tesst py-2">
                                    <SwitchInput header={{ information: {} }} />
                                    <p className="font-size-12">{checkTranslation(prop.title)}</p>
                                </div>
                            )
                        })}
                    </div>
                </FixedView>
            </div>

        );

    }
}


export default ImportModalThird;
